import axios from 'axios';

export const requestHelp = async (queryParams) => {
  const { data } = await axios.post('/users/help-request', queryParams);

  return data;
};
